const removeAccents = (value) => String(value ?? '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const normalizeArticleSearchText = (value) => removeAccents(value)
  .replace(/[\s.,\-\u2010-\u2015]/g, '');

export const normalizeArticleSearchTextWithoutConnectors = (value) => removeAccents(value)
  .replace(/[.,\-\u2010-\u2015]/g, ' ')
  .replace(/\b(?:de|del|la|el|los|las|y)\b/g, ' ')
  .replace(/\s/g, '');

export const articleMatchesSearch = (articleText, searchText) => {
  const normalizedSearch = normalizeArticleSearchText(searchText);
  if (!normalizedSearch) return true;

  const normalizedArticle = normalizeArticleSearchText(articleText);
  if (normalizedArticle.includes(normalizedSearch)) return true;

  const searchWithoutConnectors = normalizeArticleSearchTextWithoutConnectors(searchText);
  if (!searchWithoutConnectors) return false;

  return normalizeArticleSearchTextWithoutConnectors(articleText)
    .includes(searchWithoutConnectors);
};
